import React, { useEffect, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { lazy } from '@loadable/component';
import { getPodcastLandingStack } from 'features/podcast/actions';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { darkTheme } from 'theme';
import { setTopNavColorLight } from 'features/navigation/header/actions';
import styled from 'styled-components';

import CircularProgress from '@material-ui/core/CircularProgress';

import { SectionWrapper } from 'components/Section';
import MetaTags from 'components/MetaTags';

import PodcastHeader from './elements/PodcastHeader';
import PodcastFooter from './elements/PodcastFooter';
import { Divider } from '@material-ui/core';
import Container from 'src/components/Container';

const PodcastEpisodes = lazy(() => import('views/Podcast/Episodes'));
const PodcastVideos = lazy(() => import('views/Podcast/Videos'));
const PodcastDetail = lazy(() => import('views/Podcast/Detail'));

const WideContainer = styled(SectionWrapper)`
  background-color: ${darkTheme.palette.grey[900]};
  margin-top: -72px;
  width: 100%;
  min-height: 100vh;
`;

const WrapperContainer = styled.div`
  position: relative;
  z-index: 2;
`;

const BackgroundOverlayImg = styled.img`
  position: fixed;
  top: -25%;
  right: 0;
  z-index: 1;
  width: 100%;
  opacity: 0.05;
`;

const PodcastMain = styled.main`
  min-height: 100vh;
`;

const PodcastBase = React.memo(
  ({ stack, setTopNavColorLight, getPodcastLandingStack }) => {
    useEffect(() => {
      getPodcastLandingStack();
      setTopNavColorLight();
    }, [getPodcastLandingStack, setTopNavColorLight]);

    return stack ? (
      <Suspense fallback={<CircularProgress />}>
        <MetaTags stack={stack} />
        <MuiThemeProvider theme={darkTheme}>
          <PodcastMain>
            <WideContainer>
              <WrapperContainer>
                <PodcastHeader {...stack} />
                <Switch>
                  <Route
                    path="/crispr-cuts/:podcastSlug"
                    component={PodcastDetail}
                    exact
                  />
                  <Route path="/crispr-cuts" exact>
                    <>
                      <PodcastVideos />
                      <Container>
                        <Divider />
                      </Container>
                      <PodcastEpisodes />
                    </>
                  </Route>
                </Switch>
                <PodcastFooter {...stack} />
              </WrapperContainer>
              <BackgroundOverlayImg
                src={stack?.background_image_overlay?.url}
              />
            </WideContainer>
          </PodcastMain>
        </MuiThemeProvider>
      </Suspense>
    ) : null;
  }
);

export default connect(
  state => ({
    stack: state.podcastBase.stack
  }),
  { getPodcastLandingStack, setTopNavColorLight }
)(PodcastBase);
